/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
	IImportTicketsDialogData,
	ImportTicketsDialogComponent,
} from './components/import-tickets-dialog/import-tickets-dialog.component';
import { Plan, Role, Ticket, Variance, Location } from '@touchplan/common';
import { Swimlane } from 'src/app/app-data/models/Swimlane';

export function openImportDialog(
	matDialog: MatDialog,
	projectId: string,
	planId: string,
	planList$: Observable<Map<string, Plan>>,
	locationList$: Observable<Map<string, Location>>,
	roleList$: Observable<Map<string, Role>>,
	ticketList$: Observable<Map<String, Ticket>>,
	varianceList$: Observable<Map<String, Variance>>,
	swimlanesList$: Observable<Map<string, Swimlane>>
) {
	return matDialog.open(ImportTicketsDialogComponent, {
		data: {
			projectId,
			planId,
			planList: planList$,
			locationList: locationList$,
			roleList: roleList$,
			ticketList: ticketList$,
			varianceList: varianceList$,
			swimlanesList: swimlanesList$,
		} as IImportTicketsDialogData,
		disableClose: true,
		hasBackdrop: true,
	});
}
